import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import actions from 'redux/actions'
import { constants, compose, mixpanel, snowplow } from 'common/helpers'
import injectGlobals from 'decorators/injectGlobals'

import Modal from 'components/modal/Modal/Modal'

import ButtonsInRow from 'components/_new/buttons/ButtonsInRow/ButtonsInRow'
import Box from 'components/_new/layout/Box/Box'
import Button from 'components/_new/Button/Button'
import Title from 'components/_new/typography/deprecated/Title/Title'

import AddressReview from './AddressReview/AddressReview'
import BillingReview from './BillingReview/BillingReview'

import messages from './messages'
import s from './ShippingAndBillingIssuesModal.scss'


class ShippingAndBillingIssuesModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.shape({
      reasonName: PropTypes.string,
    }).isRequired,
    isProlongOfferVisible: PropTypes.bool,
  }

  static defaultProps = {
    name: constants.modals.cancelSubscription.ShippingAndBillingIssues,
  }

  componentDidMount() {
    const { data: { reasonName: reason } } = this.props

    mixpanel.track(constants.analyticsEvents.cancelFlow.billingAndShipping.start, {
      reason,
    })
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  trackCloseModal = (action) => {
    snowplow.track(constants.snowplowEvents.cancelSubscriptionStepComplete, {
      stepName: 'shipping and billing issues',
      action,
    }, false)
  }

  handleCloseModal = () => {
    this.trackCloseModal('close')
  }

  handleNeverMindClick = () => {
    this.trackCloseModal('never mind')
    this.close()
  }

  handleCancelClick = () => {
    const { data: { reasonName: reason }, isProlongOfferVisible } = this.props

    const unsubscribeData = {
      reason,
    }

    if (isProlongOfferVisible) {
      actions.models.modals.open(constants.modals.cancelSubscription.ProlongOffer, unsubscribeData)
      this.close()
    }
    else {
      actions.models.subscription.unsubscribe(unsubscribeData)
        .then(({ isRefundAvailable, refund }) => {
          if (isRefundAvailable || refund) {
            actions.models.modals.open(constants.modals.cancelSubscription.Refund, refund)
          }
          else {
            actions.models.modals.open(constants.modals.cancelSubscription.SubscriptionWasCancelled)
          }

          this.close()
        })
    }
  }

  handleAddressUpdate = () => {
    mixpanel.track(constants.analyticsEvents.cancelFlow.billingAndShipping.updateAddress, {
      placement: 'unsubscribe flow',
    })

    this.trackCloseModal('update address')
    this.close()
  }

  handleBillingUpdate = () => {
    const { data: { reasonName } } = this.props

    mixpanel.track(constants.analyticsEvents.cancelFlow.billingAndShipping.updateBilling, {
      placement: 'unsubscribe flow',
    })

    actions.models.modals.open(constants.modals.cancelSubscription.Feedback, { reasonName })
    this.close()
  }

  render() {
    const { name } = this.props

    return (
      <Modal
        name={name}
        onClose={this.handleCloseModal}
        className={s.modal}
      >
        <Box alignLeft>
          <Title message={messages.title} size="lg" />
        </Box>
        <AddressReview onClick={this.handleAddressUpdate} />
        <BillingReview onClick={this.handleBillingUpdate} />
        <Box mt="36">
          <ButtonsInRow>
            <Button
              size="md"
              title={messages.closeButton}
              onClick={this.handleNeverMindClick}
              color="brand"
            />
            <Button
              size="md"
              title={messages.justCancel}
              onClick={this.handleCancelClick}
              color="transparent"
            />
          </ButtonsInRow>
        </Box>
      </Modal>
    )
  }
}


export default compose(
  injectGlobals(({ getFeatureToggle }) => ({
    isUnsubscribeProlongedEnabled: getFeatureToggle(constants.features.unsubscribeProlonged),
  })),
  connect({
    isProlongOfferVisible: (state, props) => {
      const {
        models: {
          subscription: { currPlan: { billingPeriod }, isPaused, isUnpaused, isMonthlyPlan },
          ui: { closedPopups },
        },
      } = state
      const { isUnsubscribeProlongedEnabled } = props

      const isMonthlyPay   = billingPeriod === 1
      const wasModalClosed = closedPopups.prolongOfferModal

      return (
        isUnsubscribeProlongedEnabled
        && isMonthlyPlan
        && isMonthlyPay
        && !wasModalClosed
        && !isPaused
        && !isUnpaused
      )
    },
  }),
)(ShippingAndBillingIssuesModal)
